(function () {
  'use strict';

  function moneyFromCents(cents, fallback) {
    if (fallback) return fallback;
    var n = Number(cents) / 100;
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function openKachingCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    try {
      if (window.kachingCartApi && typeof window.kachingCartApi.refreshCart === 'function') {
        window.kachingCartApi.refreshCart();
      }
    } catch (e) {}

    var trigger =
      document.querySelector('[data-kaching-cart-open]') ||
      document.querySelector('a[href="#kaching-cart"]') ||
      document.querySelector('.kaching-cart-icon, .kaching-cart__icon, #kaching-cart-icon') ||
      document.querySelector('#kaching-cart .kaching-cart__header-close');

    // Prefer opening the drawer via app custom element / known click targets
    var drawer = document.querySelector('#kaching-cart, kaching-cart');
    if (drawer) {
      drawer.classList.add('is-open', 'active', 'open');
      drawer.setAttribute('open', '');
      document.documentElement.classList.add('kaching-cart-open');
    }

    var cartBtn =
      document.querySelector('[aria-controls="kaching-cart"]') ||
      document.querySelector('button[data-action="open-cart"]') ||
      document.querySelector('.header__icon--cart, .cart-icon-bubble, a[href="/cart"]');
    if (cartBtn && typeof cartBtn.click === 'function') {
      cartBtn.click();
    } else if (trigger && typeof trigger.click === 'function') {
      trigger.click();
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.clcReady === '1') return;
    root.dataset.clcReady = '1';

    var sid = root.getAttribute('data-section-id') || '';
    var variantId = root.getAttribute('data-variant-id');
    var sellingPlanId = root.getAttribute('data-selling-plan-id') || '';
    var otPrice = root.getAttribute('data-ot-price');
    var subPrice = root.getAttribute('data-sub-price');
    var comparePrice = root.getAttribute('data-compare-price');
    var otMoney = root.getAttribute('data-ot-money');
    var subMoney = root.getAttribute('data-sub-money');
    var compareMoney = root.getAttribute('data-compare-money');
    var savePct = root.getAttribute('data-save-pct') || '52';
    var brushUrl = root.getAttribute('data-brush-url') || '';

    var plan = 'sub';
    var isAdding = false;

    function sleep(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    // Gift is owned by EG Auto Add (app). Theme only waits so EG can react, then opens cart.
    // Do NOT cart/add the brush here — orphan gifts stay after the sub item is removed.
    function afterAddOpenCart() {
      var wait = plan === 'sub' ? 500 : 0;
      return sleep(wait)
        .then(function () {
          openKachingCart();
        })
        .catch(function () {
          openKachingCart();
        });
    }

    var CHK =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--green-600)" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    var BENS = [
      ['Save ' + savePct + '% on every delivery', true],
      ['Never run out, consistent results guaranteed', false],
      ['Free shipping today', true],
      ['Pause, skip, or cancel anytime, zero commitment', false]
    ]
      .map(function (pair) {
        return (
          '<li class="ben' +
          (pair[1] ? ' hl' : '') +
          '">' +
          CHK +
          '<span>' +
          pair[0] +
          '</span></li>'
        );
      })
      .join('');
    var GIFT =
      '<div class="giftrow"><img src="' +
      brushUrl +
      '" alt="FREE Body Brush" /><div class="t"><b>FREE Body Brush</b><span>For smooth areas only</span></div><div class="pr"><b>FREE</b><s>$15.00</s></div></div>';

    var swline = root.querySelector('#swline-' + sid) || root.querySelector('[id^="swline-"]');
    var pbox = root.querySelector('[data-plan-box]');
    var pbody = pbox ? pbox.querySelector('[data-plan-body]') : null;
    var satc = root.querySelector('#satc-' + sid) || root.querySelector('.satc');
    var satcNow = root.querySelector('[data-satc-now]');
    var satcWas = root.querySelector('[data-satc-was]');

    function renderPlan() {
      var sub = plan === 'sub';
      if (!pbox || !pbody) return;
      pbox.classList.toggle('otp', !sub);
      var nameRow = pbox.querySelector('.name-row');
      if (nameRow) {
        nameRow.innerHTML =
          '<span class="plan-name">Single Bottle</span>' +
          (sub ? '<span class="save">' + savePct + '% OFF</span>' : '');
      }
      var supply = pbox.querySelector('.supply');
      if (supply) supply.textContent = sub ? 'Autoships Every Month' : '1-Month Supply';
      var price = pbox.querySelector('.price');
      if (price) {
        price.innerHTML =
          '<span class="p-now">' +
          (sub ? subMoney : otMoney) +
          '</span>' +
          (sub ? '<span class="p-was">' + compareMoney + '</span>' : '');
      }
      pbody.innerHTML = sub ? '<ul class="bens">' + BENS + '</ul>' + GIFT : '';
      var divline = pbox.querySelector('.divline');
      if (divline) divline.hidden = !sub;
      if (swline) swline.hidden = sub;

      root.querySelectorAll('[data-plan]').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-plan') === plan);
      });

      if (satcNow) satcNow.textContent = sub ? subMoney : otMoney;
      if (satcWas) {
        satcWas.style.display = sub ? '' : 'none';
        satcWas.textContent = compareMoney;
      }
    }

    if (pbody) {
      pbody.innerHTML = '<ul class="bens">' + BENS + '</ul>' + GIFT;
    }

    function setPlan(next) {
      plan = next === 'sub' ? 'sub' : 'otp';
      renderPlan();
    }

    root.querySelectorAll('[data-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPlan(btn.getAttribute('data-plan'));
      });
    });
    if (swline) {
      swline.addEventListener('click', function () {
        if (plan !== 'sub') setPlan('sub');
      });
    }
    renderPlan();

    // Gallery
    var track = root.querySelector('#track-' + sid) || root.querySelector('.track');
    var thumbs = root.querySelector('#thumbs-' + sid) || root.querySelector('.thumbs');
    var cbadge = root.querySelector('[data-cbadge], .cbadge');
    if (track && thumbs) {
      thumbs.innerHTML = '';
      var slides = Array.prototype.slice.call(track.children);
      slides.forEach(function (s, i) {
        var img = s.querySelector('img');
        if (!img) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'th' + (i === 0 ? ' on' : '');
        b.innerHTML = '<img src="' + img.getAttribute('src') + '" alt="" />';
        b.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
        thumbs.appendChild(b);
      });
      track.addEventListener(
        'scroll',
        function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          Array.prototype.forEach.call(thumbs.children, function (t, n) {
            t.classList.toggle('on', n === i);
          });
          if (cbadge) cbadge.style.opacity = i === 0 ? '1' : '0';
        },
        { passive: true }
      );
      if (cbadge) cbadge.style.opacity = '1';
    }

    // Sticky ATC after buy box leaves viewport
    var bb = root.querySelector('.bb');
    function updSatc() {
      if (!satc || !bb) return;
      satc.classList.toggle('on', bb.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', updSatc, { passive: true });
    window.addEventListener('resize', updSatc);
    updSatc();

    // Sticky promo on scroll up
    var promo = root.querySelector('[data-promo], .promo');
    var lastY = window.scrollY || 0;
    window.addEventListener(
      'scroll',
      function () {
        if (!promo) return;
        var y = window.scrollY || 0;
        if (y < 8) {
          promo.classList.remove('is-hidden');
        } else if (y > lastY + 4) {
          promo.classList.add('is-hidden');
        } else if (y < lastY - 4) {
          promo.classList.remove('is-hidden');
        }
        lastY = y;
      },
      { passive: true }
    );

    // FAQ load more
    var faqBtn = root.querySelector('[data-faq-more]');
    var faqMore = root.querySelector('#faqMore-' + sid) || root.querySelector('.faq-more');
    if (faqBtn && faqMore) {
      faqBtn.addEventListener('click', function () {
        var on = faqMore.classList.toggle('on');
        faqBtn.textContent = on ? 'Show fewer questions' : 'Load more questions';
      });
    }

    // COA modal
    var coaModal = root.querySelector('#coaModal-' + sid) || root.querySelector('.coa-ov');
    root.querySelectorAll('.coa-btn').forEach(function (btn) {
      btn.removeAttribute('onclick');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (coaModal) coaModal.classList.add('on');
      });
    });
    if (coaModal) {
      coaModal.removeAttribute('onclick');
      coaModal.addEventListener('click', function (e) {
        if (e.target === coaModal) coaModal.classList.remove('on');
      });
      coaModal.querySelectorAll('[aria-label="Close"], .coa-hd button').forEach(function (x) {
        x.removeAttribute('onclick');
        x.addEventListener('click', function () {
          coaModal.classList.remove('on');
        });
      });
    }

    // Add to cart
    function addToCart() {
      if (isAdding || !variantId) return;
      isAdding = true;
      root.querySelectorAll('[data-clc-atc]').forEach(function (b) {
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
      });

      var item = { id: Number(variantId), quantity: 1 };
      if (plan === 'sub' && sellingPlanId) {
        item.selling_plan = Number(sellingPlanId);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart';
            console.error('[clc-ec-page01]', msg, res.data);
            alert(msg);
            return;
          }
          if (plan === 'sub') {
            return afterAddOpenCart();
          }
          openKachingCart();
        })
        .catch(function (err) {
          console.error('[clc-ec-page01] ATC failed', err);
          alert('Something went wrong. Please try again.');
        })
        .finally(function () {
          isAdding = false;
          root.querySelectorAll('[data-clc-atc]').forEach(function (b) {
            b.disabled = false;
            b.removeAttribute('aria-busy');
          });
        });
    }

    root.querySelectorAll('[data-clc-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-clc-ec-page01]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('[data-clc-ec-page01]') || e.target;
    if (root && root.hasAttribute && root.hasAttribute('data-clc-ec-page01')) {
      root.dataset.clcReady = '';
      initRoot(root);
    }
  });
})();
